module.exports = "https://static.wmbcdn.com/uniweb/images/8da7c142854b70651063903097bbdfd4.svg";